import { createFileRoute } from '@tanstack/react-router';
import { RelationDetail } from '@/features/relations/RelationDetail';

export const Route = createFileRoute('/_shell/relations/$relationId')({
  component: RelationDetailRoute,
});

function RelationDetailRoute() {
  const { relationId } = Route.useParams();
  return <RelationDetail relationId={relationId} />;
}
